import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CoreModule } from '@core/core.module';
import { AttachmentInlineComponent } from './components/attachment-inline/attachment-inline.component';
import { AttachmentManagerListComponent } from './components/attachment-manager-list/attachment-manager-list.component';
import { AttachmentManagerListV2Component } from './components/attachment-manager-list-v2/attachment-manager-list-v2.component';
import { AttachmentInlineV2Component } from './components/attachment-inline-v2/attachment-inline-v2.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [
    AttachmentManagerListComponent,
    AttachmentManagerListV2Component,
    AttachmentInlineComponent,
    AttachmentInlineV2Component
  ],
  imports: [CoreModule, MatIconModule, MatProgressBarModule],
  exports: [AttachmentManagerListComponent, AttachmentManagerListV2Component],
  providers: []
})
export class AttachmentsManageModule {}
